import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Collapsable } from '../../../Collapsable';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation, FeatureToggleInformation } from '../common';

interface AssetFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function AssetFeatureTogglesView({ company, update }: AssetFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.assets;

  return (
    <Collapsable
      open={toggles.assets}
      header={
        <FeatureToggleItem
          value={toggles.assets}
          onChange={async value => await update(copy.withAssetsFeatureToggle(value))}
        >
          <FeatureToggleTitle
            text={t(TranslationKey.assetManagementAssetManagementFeatureToggleTitle).singular.upper}
          />
          <FeatureToggleExplanation
            text={t(TranslationKey.assetManagementAssetManagementFeatureToggleExplanation).singular.upper}
          />
          <FeatureToggleInformation
            text={t(TranslationKey.assetManagementAssetManagementFeatureToggleInformation).singular.upper}
          />
        </FeatureToggleItem>
      }
    >
      <FeatureToggleItem
        indent={1}
        value={toggles.inboundOrder}
        onChange={async value => await update(copy.withAssetsInboundOrderFeatureToggle(value))}
      >
        <FeatureToggleTitle text={t(TranslationKey.assetManagementInboundOrderFeatureToggleTitle).singular.upper} />
        <FeatureToggleExplanation
          text={t(TranslationKey.assetManagementInboundOrderFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>
    </Collapsable>
  );
}
